import type { DocsLayoutProps } from "fumadocs-ui/layouts/notebook";
import { ChevronRight, Github } from "lucide-react";

import { ThemeSelect } from "../components/theme-select";

function XLogo() {
  return (
    <svg
      aria-hidden="true"
      viewBox="0 0 24 24"
      fill="currentColor"
      className="size-4"
    >
      <path d="M18.901 1.153h3.68l-8.04 9.19L24 22.846h-7.406l-5.8-7.584-6.638 7.584H.474l8.6-9.83L0 1.154h7.594l5.243 6.932 6.064-6.933Zm-1.29 19.493h2.039L6.486 3.238H4.298L17.61 20.646Z" />
    </svg>
  );
}

export function DocsFooter() {
  return (
    <footer className="not-prose flex items-center gap-4 border-t pt-6 text-fd-muted-foreground">
      <a
        href="https://x.com/inference_net"
        target="_blank"
        rel="noreferrer"
        aria-label="Inference.net on X"
        className="transition-colors hover:text-fd-foreground"
      >
        <XLogo />
      </a>
      <a
        href="https://github.com/context-labs"
        target="_blank"
        rel="noreferrer"
        aria-label="Context Labs on GitHub"
        className="transition-colors hover:text-fd-foreground"
      >
        <Github className="size-4" aria-hidden="true" />
      </a>
    </footer>
  );
}

export function baseOptions(): Pick<
  DocsLayoutProps,
  "links" | "nav" | "slots"
> {
  return {
    slots: { themeSwitch: ThemeSelect },
    nav: {
      title: (
        <>
          <img
            src="/logo/light.svg"
            alt="Inference.net"
            className="h-6 dark:hidden"
          />
          <img
            src="/logo/dark.svg"
            alt="Inference.net"
            className="hidden h-6 dark:block"
          />
        </>
      ),
      url: "/introduction",
      mode: "top",
    },
    links: [
      {
        type: "main",
        text: "Meet with Us",
        url: "https://inference.net/meet-with-us/",
        external: true,
      },
      {
        type: "main",
        text: "Support",
        url: "mailto:support@inference.net",
        external: true,
      },
      {
        type: "custom",
        children: (
          <a
            href="https://inference.net/dashboard"
            className="flex items-center gap-1 rounded-md bg-fd-primary py-2 pr-2 pl-3 text-sm font-medium text-fd-primary-foreground transition-opacity hover:opacity-90"
          >
            Dashboard
            <ChevronRight className="size-3" aria-hidden="true" />
          </a>
        ),
      },
    ],
  };
}
